import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=53a90a56&scoped=true&"
import script from "./CustomDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDashboard.vue?vue&type=style&index=0&id=53a90a56&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a90a56",
  null
  
)

export default component.exports